export default __webpack_public_path__ + "static/media/analytics-active.98e91453.svg";